var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVenzel52Color(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 5.13 5.12",
    style: {
      enableBackground: "new 0 0 5.13 5.12"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M4.53 1.5c.3-.24.6-1.18.41-1.3s-1.07.24-1.5.58c-.23.17-.47.62-.66 1.01h-.37c-.11-.53-.55-.94-1.1-.94s-.98.4-1.1.94h-.2v3.33h3.33v-.23a1.17 1.17 0 0 0 .01-2.28v-.35c.44-.25 1-.6 1.18-.75V1.5z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#412213"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.68 1.7-.01-.07a1.32 1.32 0 0 0-.92-.94C1.47.62.93.59.35 1.11c-.02 0-.03.01-.05.03-.33.28-.29.57-.3.68a.88.88 0 0 0 1.49.6l.01-.01a.9.9 0 0 0 0-1.24.9.9 0 0 0-.3-.2 1 1 0 0 1 1.18.73c.1.38-.02.78-.31 1.13-.67.24-1.68.8-1.76 1.99 1.12-.08 1.7-1.07 1.97-1.74.58-.51 1.25-.43 1.62-.06.22.22.34.55.26.92a.86.86 0 0 0-.2-.31.88.88 0 0 0-1.24 1.24.9.9 0 0 0 .53.24c.23.02.34-.03.48-.08.1-.04.27-.2.27-.2.7-.77.55-1.58.1-2.03a1.3 1.3 0 0 0-.64-.35c.74-.34 1.67-1.03 1.67-2.3V0h-.15c-1.26 0-1.95.96-2.3 1.7zm-1.4-.32a.57.57 0 0 1 0 .82.57.57 0 0 1-.8 0 .59.59 0 0 1-.02-.8l.05-.05c.23-.2.57-.18.78.03h-.01zM.71 4.4c.2-.56.66-.91 1.13-1.14-.23.47-.6.94-1.13 1.14zm3.06.22c-.1.12-.26.2-.42.2h-.03a.57.57 0 0 1-.55-.58c0-.15.05-.3.16-.4a.58.58 0 0 1 1 .4c0 .15-.06.28-.16.38zM2.73 2.4c.17-.57.74-2 2.1-2.1-.1 1.4-1.53 1.94-2.1 2.1z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#ddcaa4"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVenzel52Color);
export default __webpack_public_path__ + "static/media/venzel_5_2color.75f64b35fb72965564593d832f10249d.svg";
export { ForwardRef as ReactComponent };